/**
 * pTimeout 함수는 지정된 시간(ms) 내에 비동기 작업이 완료되지 않으면
 * 아무 값도 반환하지 않고(`void`), 다음 라인으로 넘어갈 수 있도록 합니다.
 *
 * @param promise - 타임아웃을 적용할 비동기 작업 (Promise)
 * @param ms - 타임아웃 제한 시간 (밀리초 단위)
 * @returns 지정된 시간 내에 완료되면 원래의 Promise 결과를 반환하고,
 *          시간이 초과되면 아무 값도 반환하지 않고(`void`) 다음 라인으로 진행합니다.
 *
 * 사용 예시:
 * ```typescript
 * await pTimeout(fetchData(), 200); // 200ms 내에 완료되지 않으면 아무 값도 반환하고 다음 라인으로 이동
 * console.log("비동기 작업 완료 여부와 관계없이 다음 작업을 진행합니다.");
 * ```
 */
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
export const pTimeout = <T>(promise: Promise<T>, ms: number): Promise<T | void> =>
  Promise.race([
    // 비동기 작업이 정상적으로 완료되면 그 결과를 반환
    promise,

    // 지정된 시간이 지나면 void를 resolve하여 다음 라인으로 이동
    new Promise<void>((resolve) => {
      setTimeout(() => {
        resolve();
      }, ms);
    }),
  ]);
